import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";
import { useSettings } from "../context/SettingsContext";

export const Logo = ({ to = "/", small = false, dark = false }) => {
  const { settings } = useSettings();
  const size = small ? "h-8 w-8 text-sm" : "h-9 w-9";
  return (
    <Link to={to} data-testid="app-logo" className="flex items-center gap-2 group min-w-0">
      {settings.logo ? (
        <img src={fileUrl(settings.logo)} alt={settings.app_title} className={`${size} rounded-xl object-contain bg-white`} data-testid="app-logo-image" />
      ) : (
        <span className={`grid place-items-center rounded-xl font-extrabold ${dark ? "bg-white text-slate-900" : "bg-slate-900 text-white"} ${size} transition-transform group-hover:-rotate-6`}>
          {settings.app_title[0]?.toLowerCase()}
        </span>
      )}
      <span className={`truncate font-extrabold tracking-tight text-lg ${dark ? "text-white" : "text-slate-900"}`} data-testid="app-title">
        {settings.app_title}<span className="text-[#EE4D2D]">.</span>
      </span>
    </Link>
  );
};
